import { io } from "socket.io-client";

// export const socket = io.connect("https://gpd-production.onrender.com/");
export const node_url = "https://grouplandev-nodejs.onrender.com";
// export const flask_url = "https://3642-2407-d000-1a-e856-13b-3e5c-4ad5-5a33.ngrok-free.app";
export const flask_url = "https://gpd-production.onrender.com";